import React from 'react'
import { ReadOnlyFieldDisplay } from '../../../components/ReadOnlyFieldDisplay'
import { TradeFormValues } from '../Types'
import styles from './styles.module.less'

const AllocationTradeFieldsPreview = ({
  values: { orderId, sourceAccountNumber, sourceAccountType },
}: {
  values: TradeFormValues
}) => {
  return (
    <div className={`allocation-trade-fields-preview ${styles.allocationTradeFieldsPreview}`}>
      <ReadOnlyFieldDisplay
        className="source-account-number-preview"
        label="Source Account Number"
        required
        value={sourceAccountNumber}
      />
      <ReadOnlyFieldDisplay
        className="source-account-type-preview"
        label="Source Account Type"
        required
        value={sourceAccountType}
      />
      <ReadOnlyFieldDisplay className="order-id-preview" label="Order Id" value={orderId} />
    </div>
  )
}

export default AllocationTradeFieldsPreview
